// src/PublicUser/components/tools/ToolsGrid.jsx
import React from 'react';
import ToolCard from './ToolCard';

export default function ToolsGrid({ title, tools, favorites, onToggleSave }) {
  // Enforce pricing sort tiering mechanics
  const sortedTools = [...tools].sort((a, b) => {
    const weights = { 'free': 1, 'freemium': 2, 'paid': 3 };
    return (weights[a.pricing.toLowerCase()] || 4) - (weights[b.pricing.toLowerCase()] || 4);
  });

  return (
    <div className="ts-tools-category-group-block">
      <h2 className="ts-tools-section-hdr">{title}</h2>
      <div className="ts-tools-grid">
        {sortedTools.map((tool) => (
          <ToolCard 
            key={tool.id} 
            tool={tool} 
            isSaved={favorites.includes(tool.id)}
            onToggleSave={() => onToggleSave(tool.id)}
          />
        ))}
      </div>
    </div>
  );
}